import firebase from "firebase/app";
import { Dialog } from "@capacitor/dialog";
import { Device } from "@capacitor/device";
import { Storage } from "@capacitor/storage";
import store from "@/store";
// INITIALIZATION
const firebaseConfig = {
    apiKey: "AIzaSyDFzhtlDl6LxuxyIAPuF7Gy8Ol3mdJ42_Y",
    authDomain: "bunsandbatterapp.firebaseapp.com",
    projectId: "bunsandbatterapp",
    storageBucket: "bunsandbatterapp.appspot.com",
    messagingSenderId: "962334278541",
    appId: "1:962334278541:web:db80300d2954a9a561f3c4",
    measurementId: "G-4Z3M6MQ78Q",
};
firebase.initializeApp(firebaseConfig);
// FIRESTORE
firebase
    .firestore()
    .enablePersistence({ synchronizeTabs: true })
    .then(() => {
        store.commit("appDetails");
        store.dispatch("menuFetch");
    });

// CLOUD MESSAGING
Device.getInfo().then((infoObject) => {
    var platform = infoObject.platform;
    if (platform == "web") {
        try {
            firebase.messaging().onMessage((payload) => {
                console.log("fcm message received: ", payload);
                Dialog.alert({
                    title: payload.notification.title,
                    message: payload.notification.body,
                });
            });
            firebase
                .messaging()
                .getToken({
                    vapidKey: "BJViKBxwuTLQ-WtMZwxlSdqqzHA4aUyKfCPbW4PtuzBa03GT1r36iOWZSG0iuk90aQ9Qe5yoAvSSPkhfMOUsTJM",
                })
                .then((currentToken) => {
                    Storage.get({ key: "fcmToken" }).then((tokenObject) => {
                        console.log("FCM Web Token:", currentToken);
                        var oldToken = tokenObject.value;
                        if (currentToken != oldToken) {
                            Device.getId().then((idObject) => {
                                var deviceID = idObject.uuid;
                                firebase
                                    .firestore()
                                    .collection("FCMTokens")
                                    .doc("web:" + deviceID)
                                    .set({ token: currentToken, id: deviceID, platform: "web" })
                                    .then(() => {
                                        Storage.set({ key: "fcmToken", value: currentToken }).then(
                                            () => {
                                                console.log("added web fcm to storage");
                                            }
                                        );
                                    });
                            });
                        }
                    });
                });
        } catch (error) {
            console.error(error);
        }
    }
});

// AUTHENTICATION
firebase.auth().onAuthStateChanged((user) => {
    if (user) {
        store.commit("userFetch", user.uid);
        store.commit("ordersFetch", user.uid);
    } else {
        store.commit("clearUser");
        store.commit("clearOrders");
    }
});